import React from 'react';
import { SvgIconProps } from '../types';

export default function Accessibility({
  fill,
  width,
  height,
  className,
  ariaLabel,
  ariaHidden,
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      fill="none"
      width={width}
      height={height}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g clip-path="url(#clip0_20708_74844)">
        <path
          d="M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z"
          fill={fill}
        />
        <path
          d="M27.2235 26.9216C29.2812 26.9216 33.4329 25.4945 34.4617 28.2159C35.3677 30.612 38.4143 38.8756 35.9551 39.4066C33.4959 39.9376 31.9096 32.9517 31.3056 31.6673C30.6717 30.3199 26.9713 31.8432 26.9713 31.8432L27.2202 26.9182L27.2235 26.9216Z"
          fill="white"
        />
        <path
          d="M24.24 16.0958C23.251 15.8735 22.199 15.6511 21.1834 15.6511C20.1679 15.6511 19.1126 15.9598 18.1833 16.4211C16.9786 17.0151 15.9332 17.8647 15.4487 19.1424C15.0239 20.2642 14.8214 21.4788 14.5924 22.6503C14.4962 23.1415 14.4033 23.6327 14.307 24.1238L26.5332 26.0388C29.5101 19.0263 27.197 16.7563 24.2433 16.0925L24.24 16.0958ZM19.023 22.3981L17.3901 22.9822C17.3901 22.9822 17.7087 18.6081 19.8626 18.3592L19.023 22.3981Z"
          fill="white"
        />
        <path
          d="M27.4459 15.8338C29.8873 15.8338 31.8665 13.8546 31.8665 11.4132C31.8665 8.97182 29.8873 6.99268 27.4459 6.99268C25.0045 6.99268 23.0254 8.97182 23.0254 11.4132C23.0254 13.8546 25.0045 15.8338 27.4459 15.8338Z"
          fill="white"
        />
        <path
          d="M23.1714 22.72C18.2796 20.918 12.8302 23.4336 11.0314 28.3287C9.22938 33.2205 11.745 38.6699 16.6401 40.4686C17.7054 40.8602 18.8106 41.056 19.9124 41.056C21.2631 41.056 22.6105 40.764 23.8716 40.1799C26.1649 39.1212 27.9072 37.2329 28.78 34.86C30.5821 29.9682 28.0665 24.5188 23.1714 22.72ZM25.0498 33.4893C24.5453 34.8633 23.5331 35.9585 22.2023 36.5724C21.4689 36.9109 20.689 37.0802 19.9057 37.0802C19.2652 37.0802 18.6247 36.9674 18.0074 36.7384C15.1699 35.693 13.713 32.5368 14.7551 29.6993C15.8005 26.8618 18.9566 25.4049 21.7941 26.447C24.6316 27.4924 26.0885 30.6485 25.0464 33.486L25.0498 33.4893Z"
          fill="white"
        />
        <path
          d="M19.9091 41.5539C18.7375 41.5539 17.5793 41.3448 16.4642 40.9366C11.3135 39.0416 8.66519 33.3068 10.5602 28.1562C12.4552 23.0055 18.19 20.3572 23.3406 22.2521C28.4913 24.1471 31.1396 29.8819 29.2446 35.0326C28.3254 37.5283 26.4901 39.5162 24.0774 40.6313C22.7532 41.2419 21.3494 41.5539 19.9091 41.5539ZM19.9124 22.6338C16.2651 22.6338 12.8269 24.8806 11.4961 28.498C9.79024 33.1343 12.1731 38.2949 16.8094 40.0007C17.8116 40.3691 18.857 40.5583 19.9091 40.5583C21.2034 40.5583 22.4678 40.2795 23.6592 39.7286C25.833 38.7263 27.4824 36.9342 28.3088 34.6907C30.0146 30.0545 27.6317 24.8939 22.9955 23.188C21.9799 22.813 20.9345 22.6371 19.9091 22.6371L19.9124 22.6338ZM19.9057 37.578C19.2022 37.578 18.5052 37.4519 17.8382 37.2063C14.7418 36.068 13.1521 32.6232 14.2904 29.5268C15.4288 26.4337 18.8736 24.8408 21.97 25.9791C25.063 27.1174 26.656 30.5622 25.5177 33.6586C24.9668 35.1587 23.8617 36.3534 22.4114 37.0238C21.6149 37.3922 20.7719 37.578 19.9057 37.578ZM19.9091 26.6096C17.878 26.6096 15.9664 27.8608 15.2263 29.872C14.7683 31.1198 14.8214 32.4738 15.3823 33.6819C15.9399 34.8932 16.9355 35.8125 18.1833 36.2705C19.4278 36.7284 20.7918 36.6753 21.9965 36.1178C23.2046 35.5603 24.1238 34.5646 24.5851 33.3135C25.5343 30.7348 24.2101 27.8641 21.6282 26.9116C21.0607 26.7026 20.4832 26.603 19.9124 26.603L19.9091 26.6096Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_20708_74844">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
